import { render, staticRenderFns } from "./MouvementDetailModal.vue?vue&type=template&id=2bbb88d0"
import script from "./MouvementDetailModal.vue?vue&type=script&lang=ts"
export * from "./MouvementDetailModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports